import type { InterfaceInputToken } from '@morpho-org/dapp-core'
import type { Address } from 'viem'

/**
 * A token label from an oRPC procedure, in the shape `parseApiAsset` and the token cells read. The
 * cells choose an amount's digits from `priceUsd`, so a priced token must pass it.
 */
export function toInterfaceInputToken(
  token: {
    address: Address
    decimals: number
    symbol: string | null
    logoUri: string | null
    priceUsd: number | null
  },
  chainId: number
): InterfaceInputToken {
  const symbol = token.symbol ?? undefined
  return {
    address: token.address,
    symbol,
    name: symbol,
    decimals: token.decimals,
    logoURI: token.logoUri,
    chain: { id: chainId },
    price: token.priceUsd === null ? undefined : { usd: token.priceUsd }
  }
}
